/**
 * 管理导航
 */
let menuList = [
  {
        id: '1',
        href: '/system-manage',
        name: '系统管理',
        active: false,
        icon: 'el-icon-document',
        children: [
            // {
            //     id: '1-1',
            //     href: '/system-manage/account',
            //     name: '账号管理',
            //     active: false,
            // },
            // {
            //     id: '1-2',
            //     href: '/system-manage/role',
            //     name: '角色管理',
            //     active: false,
            // },
            // {
            //     id: '1-3',
            //     href: '/system-manage/log',
            //     name: '系统日志',
            //     active: false,
            // }

        ]
    },
    {
        id: '2',
        href: '/enroll-manage',
        name: '报名管理',
        active: false,
        icon: 'el-icon-monitor',
        children: [
            // {
            //     id: '2-1',
            //     href: '/enroll-manage/data',
            //     name: '数据管理',
            //     active: false,
            // },
            // {
            //     id: '2-2',
            //     href: '/enroll-manage/form',
            //     name: '表单管理',
            //     active: false,
            // }
        ]
    },
]

let accountMenu = {
        id: '1-1',
        href: '/system-manage/account',
        name: '账号管理',
        active: false,
    }
let roleMenu = {
    id: '1-2',
    href: '/system-manage/role',
    name: '角色管理',
    active: false,
}
let systemLogMenu = {
    id: '1-3',
    href: '/system-manage/log',
    name: '系统日志',
    active: false,
}
let dataMenu = {
    id: '2-1',
    href: '/enroll-manage/data',
    name: '数据管理',
    active: false,
}
let formMenu = {
    id: '2-2',
    href: '/enroll-manage/form',
    name: '表单管理',
    active: false,
}

let getRoleMenu = (menuConfig) => {
    let menu = JSON.parse(JSON.stringify(menuList))
    for(let i=0;i<menuConfig.length;i++) {
        let item = menuConfig[i]
        switch (item.menuItem) {
            case 'system.account':menu[0].children.push(accountMenu);break
            case 'system.role':menu[0].children.push(roleMenu);break
            case 'system.log':menu[0].children.push(systemLogMenu);break
            case 'enroll.data':menu[1].children.push(dataMenu);break
            case 'enroll.form':menu[1].children.push(formMenu);break

        }
    }
    if(menu[0] && menu[0].children.length == 0) {
        menu.splice(0,1)
    }
    if(menu[1] && menu[1].children.length == 0) {
        menu.splice(1,1)
    }
    return menu
}
export default {
  menuList,
    accountMenu,
    roleMenu,
    systemLogMenu,
    dataMenu,
    formMenu,
    getRoleMenu
}
